import React, { useState, useEffect } from 'react';

const AdvancedSearchInput = ({ value: externalValue, onChange, placeholder = "Search...", className = "" }) => {
  // 1. حالة محلية لإدارة النص أثناء الكتابة السريعة
  const [localValue, setLocalValue] = useState(externalValue);

  // 2. تحديث الحالة المحلية إذا تغيرت القيمة الخارجية (مثلاً عند مسح البحث من الأب)
  useEffect(() => {
    setLocalValue(externalValue);
  }, [externalValue]);

  // 3. تطبيق الـ Debounce: لا نرسل الطلب للسيرفر إلا بعد توقف المستخدم عن الكتابة بـ 500ms
  useEffect(() => {
    const handler = setTimeout(() => {
      if (localValue !== externalValue) {
        onChange(localValue);
      }
    }, 500);

    return () => clearTimeout(handler); // تنظيف المؤقت عند كتابة حرف جديد
  }, [localValue, onChange, externalValue]);

  const handleClear = () => {
    setLocalValue("");
    onChange("");
  };

  return (
    <div className={`flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto ${className}`}>
      <div style={{ position: 'relative', width: '100%', maxWidth: '320px' }}>
        
        {/* أيقونة البحث */}
        <span style={{ 
          position: 'absolute', 
          left: '12px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          zIndex: 10,
          pointerEvents: 'none',
          fontSize: '14px'
        }}>
          🔍
        </span>

        <input
          type="text"
          placeholder={placeholder}
          className="login-input !mb-0"
          style={{ 
            width: '100%', 
            paddingTop: '10px', 
            paddingBottom: '10px', 
            paddingLeft: '40px', 
            paddingRight: '40px', 
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            backgroundColor: '#f9fafb',
            fontSize: '14px'
          }}
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
        />

        {/* زر المسح الذكي */}
        {localValue && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '22px',
              height: '22px',
              backgroundColor: '#e2e8f0',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'none',
              cursor: 'pointer',
              fontSize: '10px',
              fontWeight: 'bold',
              color: '#64748b',
              zIndex: 20,
              transition: 'all 0.2s'
            }}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default AdvancedSearchInput;